export const WA_INTERNAL_EMAIL_DOMAINS = [
  "@thenew.business",
  "@thenewbusiness.ca",
  "@whereabouts.tech",
] as const;
